module.exports = __webpack_public_path__ + "static/plate-processing-69b0d709c8726d4fa8b1f33ab713a3fb.jpg";